import type { JSX } from 'react'

export const ErrorFallback = ({
  error,
  componentStack,
  resetError,
}: {
  error: unknown
  componentStack: string
  eventId: string
  resetError: () => void
}): JSX.Element => {
  const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred'

  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'system-ui',
      padding: '40px 20px',
    }}>
      <div style={{ width: '100%', maxWidth: '800px' }}>
        <h1 style={{ color: '#dc2626', marginBottom: '8px' }}>Something went wrong</h1>
        <p style={{ color: '#4b5563', marginBottom: '24px', fontWeight: 500 }}>
          {errorMessage}
        </p>
        {componentStack && (
          <details open style={{ marginBottom: '24px' }}>
            <summary style={{ cursor: 'pointer', color: '#6b7280', fontSize: '13px', marginBottom: '8px' }}>
              Component stack
            </summary>
            <pre style={{
              background: '#f3f4f6',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              padding: '12px',
              fontSize: '12px',
              overflowX: 'auto',
              color: '#374151',
              whiteSpace: 'pre-wrap',
            }}>
              {componentStack}
            </pre>
          </details>
        )}
        <button
          onClick={resetError}
          style={{
            backgroundColor: '#2563eb',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          Try again
        </button>
      </div>
    </div>
  )
}
